import Cookie from "js-cookie";

export default class Service {
  static getAPI = () => `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}`;
  static token = () => Cookie.get("aTkn");
}

export class Response {
  public response: object;
}
